<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <div>{{ 'MATERIAL.ENTER_SITEWELLAWAREID' | translate }}</div>
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>

    <div class="form-grid">

      <div><df-input block [(value)]="siteWellawareId" /></div>

    </div>

    <div class="footer">
      <df-button variant="primary" (onClick)="addSiteWellawareId()" [disabled]="!isValid()">{{ 'CONFIRM' | translate }}</df-button>
    </div>
      
  </div>
</div>